import React from "react";
import { PlusOutlined, FileExcelOutlined } from "@ant-design/icons";
import { Drawer, Button, PageHeader } from "antd";
import { useState } from "react";
import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";
import DrawableCloseIcon from "../../components/common/DrawableCloseIcon";
import { DEFAULT_MASTER_DRAWER_WIDTH } from "../../utility/Constants";
import commonUtility from "../../utility/Utils";
import { ALL_CUSTOMER_XLS_URL, CLUB_LIST_PRINT_URL } from "../../utility/URL";
import GeneralCustomerEntry from "../../components/masters/general-customer/GeneralCustomerEntry";
import GeneralCustomerList from "../../components/masters/general-customer/GeneralCustomerList";

const GeneralCustomer = () => {
  const [visible, setVisible] = useState(false);
  const [customerAddData, setcustomerAddData] = useState({
    customer_id: 0,
    customer_name: '',
    address: '',
    gstin_no: '',
    mode: "ADD"
  });

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  return (
    <div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Customers"
          subTitle=""
          extra={[
            <Button key="1" className="custom-button-white" shape="round" onClick={showDrawer}>
              <PlusOutlined /> Add
            </Button>,

            <Button key="2" className="custom-button-white" shape="round" size="medium" onClick={() => commonUtility.openInNewTab(ALL_CUSTOMER_XLS_URL)}>
              <FileExcelOutlined /> Excel
            </Button>,
          ]}
        ></PageHeader>

        <Drawer
          title="Add New Customer"
          width={DEFAULT_MASTER_DRAWER_WIDTH}
          onClose={onClose}
          visible={visible}
          bodyStyle={{
            paddingBottom: 80,
          }}
          destroyOnClose={true}
          closeIcon={<><DrawableCloseIcon /></>}
        >
          <GeneralCustomerEntry data={customerAddData} onDrawerClose={onClose} />
        </Drawer>

        <div className="tableView">
          <div className="form-content">
            {/* <TimeSlotList /> */}
            <GeneralCustomerList />
          </div>
        </div>

      </div>
    </div>
  );
}
export default GeneralCustomer;